<template>
  <div class="membership">
    <div class="log-card">
      <div class="page-header">
        <span class="page-title">入会申请</span>
        <div class="action-buttons">
          <el-button size="mini" type="warning" @click="downloadForm">下载入会申请表</el-button>
          <el-button size="mini" type="warning" @click="saveForm">保存草稿</el-button>
          <el-button size="mini" type="warning" @click="submitForm">提交审核</el-button>
          <el-button size="mini" type="warning" @click="showProgress">审核进度</el-button>
        </div>
      </div>
      
      <div class="form-container" id="applicationForm">
        <div class="form-header">
          <div class="header-line1">攀枝花东区社会工作协会</div>
          <div class="header-line2">( 个人会员申请表 )</div>
          <div class="header-line3">攀枝花东区社会工作协会：</div>      
          <div class="header-line3 text">本人已认真阅读攀枝花东区社会工作协会的会员制度，现申请成为攀枝花东区社会工作协会的个人会员。</div>
          <div class="header-line3 date-row">
            <span>编号：</span>
            <span>申请入会日期：{{ applicationDate }}</span>
          </div>
          <div class="header-line4">上传身份证照片正反面: </div>       
        </div>
        <table class="application-table">
          <tbody>
            <tr>
              <td class="label">姓名</td>
              <td colspan="2"><input type="text" v-model="form.name"></td>
              <td class="label">性别</td>
              <td colspan="2"><input type="text" v-model="form.gender"></td>
              <td class="label">出生日期</td>
              <td colspan="2"><input type="text" v-model="form.birthDate"></td>
              <td rowspan="3" class="photo-cell">
                <div class="photo-container" @click="handlePhotoUpload">
                  <img v-if="form.photo" :src="form.photo" class="photo-image"/>
                  <div v-else class="photo-placeholder"></div>
                </div>
                <input type="file" ref="photoInput" @change="handlePhotoChange" accept="image/*" style="display: none"/>
              </td>
            </tr>
            <tr>
              <td class="label">民族</td>
              <td colspan="2"><input type="text" v-model="form.ethnicity"></td>
              <td class="label">文化程度</td>
              <td colspan="2"><input type="text" v-model="form.highestEducation"></td>
              <td class="label">专业</td>
              <td colspan="2"><input type="text" v-model="form.major"></td>
            </tr>
            <tr>
              <td class="label">身份证号</td>
              <td colspan="9"><input type="text" v-model="form.idCard"></td>
            </tr>
            <tr>
              <td class="label">联系电话</td>
              <td colspan="9"><input type="text" v-model="form.phone"></td>
            </tr>
            <tr>
              <td class="label">电子邮箱</td>
              <td colspan="9"><input type="text" v-model="form.email"></td>
            </tr>
            <tr>
              <td class="label">通讯地址</td>
              <td colspan="6"><input type="text" v-model="form.contactAddress"></td>
              <td class="label">邮编</td>
              <td colspan="2"><input type="text" v-model="form.zipCode"></td>
            </tr>
            <tr>
              <td class="label" colspan="2">工作单位及部门</td>
              <td colspan="5"><input type="text" v-model="form.employer"></td>
              <td class="label">所任职务</td>
              <td colspan="2"><input type="text" v-model="form.position"></td>
            </tr>
            <tr>
              <td class="label" colspan="2">工作单位性质</td>
              <td colspan="8"><input type="text" v-model="form.unitNature"></td>
            </tr>
            <tr>
              <td class="label" colspan="2">从事的服务领域</td>
              <td colspan="8"><input type="text" v-model="form.workField"></td>
            </tr>
            <tr>
              <td class="label" colspan="2">爱好特长</td>
              <td colspan="3"><input type="text" v-model="form.hobbies"></td>
              <td class="label">工作简历</td>
              <td colspan="4"><input type="text" v-model="form.resume"></td>
            </tr>
            <tr>
              <td class="label" colspan="2">是否有社工师资格证</td>
              <td colspan="3"><input type="text" v-model="form.hasCertificate"></td>
              <td class="label" colspan="2">等级（答否者不填）</td>
              <td colspan="3"><input type="text" v-model="form.certificateLevel"></td>
            </tr>
            <tr>
              <td rowspan="2" colspan="3" class="label">可用于参加协会活动的时间</td>
              <td class="label">周一</td>
              <td class="label">周二</td>
              <td class="label">周三</td>
              <td class="label">周四</td>
              <td class="label">周五</td>
              <td class="label">周六</td>
              <td class="label">周日</td>
            </tr>
            <tr>
              <td><input type="text" v-model="form.availableTime.monday"></td>
              <td><input type="text" v-model="form.availableTime.tuesday"></td>
              <td><input type="text" v-model="form.availableTime.wednesday"></td>
              <td><input type="text" v-model="form.availableTime.thursday"></td>
              <td><input type="text" v-model="form.availableTime.friday"></td>
              <td><input type="text" v-model="form.availableTime.saturday"></td>
              <td><input type="text" v-model="form.availableTime.sunday"></td>
            </tr>
            <tr>
              <td colspan="5" class="bottom-center">
                <input type="text" v-model="form.year" class="date-input"/>年<input type="text" v-model="form.month" class="date-input"/>月<input type="text" v-model="form.day" class="date-input"/>日
              </td>
              <td colspan="5" class="bottom-center">
                <div class="signature-section">
                  <div class="signature-row left-align">协会负责人签名：<img v-if="form.leaderSignature" :src="form.leaderSignature" class="signature-image" @click="openSignatureDialog"/><span v-else class="signature-placeholder" @click="openSignatureDialog"></span></div>
                  <div class="signature-row">审批日期：<input type="text" v-model="form.approvalYear" class="date-input"/>年<input type="text" v-model="form.approvalMonth" class="date-input"/>月<input type="text" v-model="form.approvalDay" class="date-input"/>日</div>
                  <div class="signature-row">（协会公章）</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <el-dialog title="审核进度" :visible.sync="dialogVisible" width="600px">
      <el-timeline>
        <el-timeline-item
          v-for="(activity, index) in progressData"
          :key="index"
          :timestamp="activity.timestamp"
          :color="activity.color">
          {{activity.content}}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>

    <el-dialog title="手写签名" :visible.sync="signatureDialogVisible" width="400px" :before-close="handleSignatureDialogClose">
      <div class="signature-dialog-content">
        <canvas ref="signatureCanvas" width="350" height="150" @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing" @mouseleave="stopDrawing" class="signature-dialog-canvas"></canvas>
        <div class="signature-dialog-buttons">
          <el-button @click="clearSignature" size="small">取消</el-button>
          <el-button @click="saveSignature" type="primary" size="small">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return {
      dialogVisible: false,
      signatureDialogVisible: false,
      isDrawing: false,
      ctx: null,
      applicationDate: '',
      form: {
        name: '',
        gender: '',
        birthDate: '',
        ethnicity: '',
        highestEducation: '',
        major: '',
        idCard: '',
        phone: '',
        email: '',
        contactAddress: '',
        zipCode: '',
        employer: '',
        position: '',
        unitNature: '',
        workField: '',
        hobbies: '',
        resume: '',
        hasCertificate: '',
        certificateLevel: '',
        availableTime: {
          monday: '',
          tuesday: '',
          wednesday: '',
          thursday: '',
          friday: '',
          saturday: '',
          sunday: ''
        },
        year: '',
        month: '',
        day: '',
        leaderSignature: '',
        approvalYear: '',
        approvalMonth: '',
        approvalDay: '',
        photo: ''
      },
      progressData: [
        {
          content: '提交入会申请',
          timestamp: '2024-01-10 10:00',
          color: '#409EFF'
        },
        {
          content: '审核中',
          timestamp: '2024-01-11 14:30',
          color: '#E6A23C'
        }
      ]
    }
  },
  created(){
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')
    this.applicationDate = `${year}年${month}月${day}日`
    this.loadSavedForm()
  },
  methods:{
    openSignatureDialog(){
      this.signatureDialogVisible = true
      this.$nextTick(() => {
        this.initCanvas()
      })
    },
    handleSignatureDialogClose(done){
      this.signatureDialogVisible = false
      done()
    },
    initCanvas(){
      const canvas = this.$refs.signatureCanvas
      if(canvas){
        this.ctx = canvas.getContext('2d')
        this.ctx.strokeStyle = '#000'
        this.ctx.lineWidth = 2
        this.ctx.lineCap = 'round'
        this.ctx.clearRect(0, 0, canvas.width, canvas.height)
      }
    },
    startDrawing(e){
      this.isDrawing = true
      const canvas = this.$refs.signatureCanvas
      const rect = canvas.getBoundingClientRect()
      this.ctx.beginPath()
      this.ctx.moveTo(e.clientX - rect.left, e.clientY - rect.top)
    },
    draw(e){
      if(!this.isDrawing) return
      const canvas = this.$refs.signatureCanvas
      const rect = canvas.getBoundingClientRect()
      this.ctx.lineTo(e.clientX - rect.left, e.clientY - rect.top)
      this.ctx.stroke()
    },
    stopDrawing(){
      this.isDrawing = false
    },
    clearSignature(){
      const canvas = this.$refs.signatureCanvas
      this.ctx.clearRect(0, 0, canvas.width, canvas.height)
    },
    saveSignature(){
      const canvas = this.$refs.signatureCanvas
      const dataURL = canvas.toDataURL()
      this.form.leaderSignature = dataURL
      this.signatureDialogVisible = false
      this.$message.success('签名已保存')
    },
    handlePhotoUpload(){
      this.$refs.photoInput.click()
    },
    handlePhotoChange(event){
      const file = event.target.files[0]
      if(file){
        const reader = new FileReader()
        reader.onload = (e) => {
          this.form.photo = e.target.result
          this.$message.success('照片已上传')
        }
        reader.readAsDataURL(file)
      }
    },
    loadSavedForm(){
      const savedForm = localStorage.getItem('membershipApplicationForm')
      if(savedForm){
        this.form = JSON.parse(savedForm)
      }
    },
    saveForm(){
      localStorage.setItem('membershipApplicationForm', JSON.stringify(this.form))
      this.$message.success('表单已保存')
    },
    submitForm(){
      if(!this.form.name || !this.form.idCard || !this.form.phone){
        this.$message.warning('请填写必填信息（姓名、身份证号、联系电话）')
        return
      }
      this.$message.success('申请已提交，请等待审核')
      localStorage.removeItem('membershipApplicationForm')
      this.progressData.push({
        content: '已提交审核',
        timestamp: new Date().toLocaleString(),
        color: '#67C23A'
      })
    },
    showProgress(){
      this.dialogVisible = true
    },
    downloadForm(){
      const element = document.getElementById('applicationForm')
      const printWindow = window.open('', '_blank')
      const htmlContent = '<html><head><title>入会申请表</title><style>' +
        'body { font-family: SimSun, serif; padding: 20px; }' +
        '.form-header { margin-bottom: 20px; }' +
        '.header-line1 { text-align: center; font-size: 28px; color: #666667; margin-bottom: 10px; }' +
        '.header-line2 { text-align: center; font-size: 28px; color: #666667; margin-bottom: 10px; }' +
        '.header-line3 { font-size: 16px; color: #333; text-align: left; }' +
        '.date-row { position: relative; display: flex; justify-content: flex-start; }' +
        '.date-row span:last-child { position: absolute; left: 60%; }' +
        '.text { text-indent: 2em; }' +
        'table { width: 100%; border-collapse: collapse; }' +
        'td { border: 1px solid #000; padding: 10px; vertical-align: middle; height: 40px; font-size: 16px; }' +
        'td.label { font-weight: bold; color: #333;  text-align: left; border: 1px solid #000; }' +
        'td.bottom-center { vertical-align: bottom; text-align: center; padding-bottom: 10px; white-space: nowrap; }' +
        'input, select, textarea { width: 100%; padding: 5px; border: none; font-size: 16px; outline: none; background: transparent; }' +
        '.date-input { width: 50px; display: inline-block; text-align: center; margin: 0 2px; }' +
        '.signature-section { width: 100%; }' +
        '.signature-row { margin-bottom: 5px; }' +
        '.signature-row.left-align { text-align: left; }' +
        '.signature-row.left-align .signature-input { text-align: left; }' +
        '.signature-space { display: inline-block; width: 150px; border-bottom: 1px solid #000; }' +
        '.signature-input { width: 200px; display: inline-block; text-align: center; }' +
        '.signature-canvas { display: inline-block; vertical-align: middle; border-bottom: 1px solid #000; }' +
        '.signature-btn { margin-left: 5px; padding: 2px 8px; font-size: 12px; cursor: pointer; background: #fff; border: 1px solid #dcdfe6; border-radius: 4px; }' +
        '.signature-image { display: inline-block; vertical-align: middle; max-width: 150px; max-height: 40px; cursor: pointer; }' +
        '.signature-placeholder { display: inline-block; vertical-align: middle; cursor: pointer; min-width: 150px; min-height: 40px; }' +
        '.photo-cell { width: 100px; padding: 0; vertical-align: middle; }' +
        '.photo-container { display: flex; flex-direction: column; align-items: center; justify-content: center; width: 100%; height: 100%; }' +
        '.photo-image { width: 100px; height: 130px; object-fit: cover; display: block; }' +
        '.photo-placeholder { width: 100px; height: 130px; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #999; font-size: 12px; cursor: pointer; }' +
        'textarea { resize: vertical; min-height: 80px; }' +
        '@media print { body { padding: 0; } }' +
        '</style></head><body>' +
        element.outerHTML +
        '<script>window.onload = function() { window.print(); window.onafterprint = function() { window.close(); }; }<' + '/script></body></html>'
      printWindow.document.write(htmlContent)
      printWindow.document.close()
    }
  }
}
</script>

<style lang="less" scoped>
.membership{
  min-height: 100%;
  .log-card{
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    min-height: 100%;
    .page-header{
      margin-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .page-title{
        font-size: 20px;
        color: #333333;
        font-weight: bold;
      }
    }
    .action-buttons{
      display: flex;
      gap: 12px;
    }
    .form-container{
      padding: 20px;
      border-radius: 8px;
      overflow-x: auto;
      .form-header{
        // margin-bottom: 20px;
        .header-line1{
          text-align: center;
          font-size: 28px;
          color: #666667;
          margin-bottom: 10px;
        }
        .header-line2{
          text-align: center;
          font-size: 28px;
          color: #666667;
          margin-bottom: 10px;
        }
        .header-line3{
          font-size: 16px;
          color: #666667;
          line-height: 25px;
        }
         .header-line4{
          font-size: 16px;
          color: #333;
          line-height: 25px;
          font-weight: bold;
        }
        .date-row{
          position: relative;
          display: flex;
          justify-content: flex-start;
          span:last-child{
            position: absolute;
            left: 60%;
          }
        }
        .text{
          text-indent: 2em;
        }
      }
    }
    .application-table{
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      tbody{
        // tr:first-child{
        //   td:nth-child(1),
        //   td:nth-child(3),
        //   td:nth-child(5){
        //     width: 10%;
        //   }
        //   td:nth-child(2),
        //   td:nth-child(4),
        //   td:nth-child(6){
        //     width: 15%;
        //   }
        //   td:nth-child(7){
        //     width: 20%;
        //   }
        // }
        tr{
          td{
            border: 1px solid #000;
            padding: 10px;
            vertical-align: middle;
            height: 45px;
            font-size: 16px;
            &.label{
              // font-weight: bold;
              color: #333;
              // width: 12%;
              text-align: left;
              border: 1px solid #000;
            }
            &.bottom-center{
              text-align: center;
              padding-bottom: 10px;
              white-space: nowrap;
            }
            input, select, textarea{
              width: 100%;
              padding: 8px;
              border: none;
              font-size: 16px;
              outline: none;
              background: transparent;
            }
            .date-input{
              width: 50px;
              display: inline-block;
              text-align: center;
              margin: 0 2px;
            }
            .signature-section{
              width: 100%;
            }
            .signature-row{
              margin-bottom: 5px;
              &.left-align{
                text-align: left;
              }
            }
            .signature-input{
              width: 200px;
              display: inline-block;
              // text-align: center;
            }
            .signature-canvas{
              display: inline-block;
              vertical-align: middle;
              border-bottom: 1px solid #000;
            }
            .signature-btn{
              margin-left: 5px;
              padding: 2px 8px;
              font-size: 12px;
              cursor: pointer;
              background: #fff;
              border: 1px solid #dcdfe6;
              border-radius: 4px;
              &:hover{
                background: #f5f7fa;
                border-color: #c6e2ff;
              }
            }
            .signature-image{
              display: inline-block;
              vertical-align: middle;
              max-width: 150px;
              max-height: 40px;
              cursor: pointer;
            }
            .signature-placeholder{
              display: inline-block;
              vertical-align: middle;
              cursor: pointer;
              min-width: 150px;
              min-height: 40px;
            }
            .photo-cell{
              // width: 100px;
              width: 100px;
              height: 130px;
              padding: 0;
              vertical-align: middle;
              .photo-container{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 100%;
              }
              .photo-image{
                width: 100%;
                height: 130px;
                object-fit: cover;
                display: block;
              }
              .photo-placeholder{
                width: 100px;
                height: 130px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: #999;
                font-size: 12px;
                cursor: pointer;
                &:hover{
                  color: #409EFF;
                }
              }
            }
            textarea{
              resize: vertical;
              min-height: 80px;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.signature-dialog-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  .signature-dialog-canvas{
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: crosshair;
    background: #fff;
  }
  .signature-dialog-buttons{
    margin-top: 20px;
    display: flex;
    gap: 10px;
  }
}
</style>
